import { formatBoolean } from "@/shared/text";

import type { FilterDataType } from "./filters";

/**
 * What a missing value reads as, everywhere one is shown: the "is any of"
 * picker's row and chip, a chart legend's series, the drill-down's group
 * column.
 * Matches the "is not set" / "is set" operators; "null" is the storage term
 * only.
 */
export const NOT_SET_LABEL = "Not set";

/** A value's display text: itself when present, {@link NOT_SET_LABEL} when missing. */
export function valueOrNotSet(value: string | null): string {
  return value ?? NOT_SET_LABEL;
}

/**
 * A group key's display text: a chart legend's series, the drill-down's group
 * column.
 *
 * Group keys arrive as text whatever the field, so a boolean field's keys are
 * `"true"` / `"false"`; they read as {@link formatBoolean} does. Only
 * `fieldType` says a key is a boolean — a string field may hold the text
 * `"true"` — so any other field's key reads as written.
 */
export function groupKeyLabel(
  key: string | null,
  fieldType?: FilterDataType,
): string {
  if (fieldType === "boolean" && (key === "true" || key === "false")) {
    return formatBoolean(key === "true");
  }
  return valueOrNotSet(key);
}
